import reducer from './reducer';
import saga from './saga';
import * as selectors from './selectors';
import {actionMeta} from './meta';

export default {
  api: actionMeta.urlBuilders,
  actions: actionMeta.actionCreators,
  constants: actionMeta.identifiers,
  saga: saga,
  reducer: reducer,
  selectors: selectors
};



// WEBPACK FOOTER //
// ./src/storeState/users/index.js